/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { V2RequestBuilderNavigationMetadata, V2RequestBuilderRequestsMetadata } from './v2/index.js';
/**
 * Uri template for the request builder.
 */
export const ClientsRequestBuilderUriTemplate = "{+baseurl}/admin/api/{realmName}/clients";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ClientsRequestBuilderNavigationMetadata = {
    v2: {
        requestsMetadata: V2RequestBuilderRequestsMetadata,
        navigationMetadata: V2RequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=index.js.map